import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import theme from '@ep/theme';
import React from 'react';

const StyledContainer = styled(Container)`
  margin-top: 2rem;
  margin-bottom: 3rem;
  height: 20rem;
  ${theme.mediaQueries.tablet} {
    height: 17rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  ${theme.mediaQueries.mobile} {
    height: 10rem;
    margin-top: 2rem;
    margin-bottom: 0rem;
  }
`;

const Header = styled('div')`
  color: ${theme.colors.duskBlue};
  font-family: ${theme.typography.primaryFont.regular};
  font-size: 2rem;
  margin-top: 3rem;
  padding-top: 3rem;
  padding-bottom: 4rem;
  border-bottom: 5px solid ${theme.colors.duskBlue};
  max-width: 1100px;
  margin: auto auto;
  height: 3rem;
  text-align: center;
  span {
    font-weight: bold;
  }
  ${theme.mediaQueries.tablet} {
    max-width: 800px;
    padding-top: 2rem;
  }
  ${theme.mediaQueries.mobile} {
    max-width: 400px;
    padding-top: 2rem;
    font-size: 1.2rem;
    border-bottom: 3px solid ${theme.colors.duskBlue};
  }
`;

function SocialWallModule() {
  return (
    <>
      <Header>
        <span>Social Wall</span> - central_casting
      </Header>
      <StyledContainer>
        <iframe
          title="Social Media portal"
          src="https://widget.tagembed.com/298292?website=1"
          style={{ width: '100%', height: '100%' }}
          frameborder="0"
          allowtransparency="true"
          sandbox
        ></iframe>
      </StyledContainer>
    </>
  );
}

export default React.memo(SocialWallModule);
